import { render, staticRenderFns } from "./DropdownUserDuties.vue?vue&type=template&id=35032e70&scoped=true&"
import script from "./DropdownUserDuties.vue?vue&type=script&lang=js&"
export * from "./DropdownUserDuties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35032e70",
  null
  
)

export default component.exports